import LotteriesEnum from '@data/lotteries';
import getCookie from '@helpers/getCookie';
import ApiRoot from '@http/ApiRoot';
import DrawModel from '@models/DrawModel';

export default async function (options) {
  const parsedOptions = {
    productID: options.productID,
    drawNumber: options.drawNumber,
    categoryID: options.categoryID || 1,
    lotteryID: options.lotteryID,
    shoppingCartID: false,
    isOrdered: options.isOrdered
  }

  parsedOptions.shoppingCartID = parseInt(parsedOptions.categoryID) === 2 ? getCookie('cart') : false;

  if (
    parsedOptions.categoryID &&
    parseInt(parsedOptions.categoryID) === 2 &&
    ((!parsedOptions.isOrdered && !parsedOptions.shoppingCartID) || !parsedOptions.lotteryID)
  ) {
    return new Error('Não Encontrado.');
  }

  try {
    const game = await ((!parsedOptions.isOrdered && parsedOptions.shoppingCartID)
      ? ApiRoot.get('viewyourgame', {
        params: {
          shoppingCartID: parsedOptions.shoppingCartID,
          drawNumber: parsedOptions.drawNumber,
          lotteryID: parsedOptions.lotteryID
        }
      })
      : ApiRoot.get('viewgame', {
        params: {
          productID: parsedOptions.productID,
          drawNumber: parsedOptions.drawNumber
        }
      }));

    if (!game) return new Error('Jogo não encontrado.')

    let lottery = null

    if (game.productSummary) {
      if (game.productSummary.lotteryID) {
        lottery = LotteriesEnum.find(
          (a) => a.id === game.productSummary.lotteryID
        )
      }
      if (game.productSummary.lotteryID && game.draw.isEspecial) {
        lottery = LotteriesEnum.find(
          (a) => a.id === game.productSummary.lotteryID && a.special === true
        )
      }
      if (game.productSummary.productName && game.productSummary.lotteryID !== 5) {
        game.productSummary.domain = game.productSummary.productName
          .split('-')
          .slice(1, -1)
          .join('-')
        game.productSummary.serie = game.productSummary.productName
          .split('-')
          .slice(-1)[0]

        if (!game.productSummary.domain) {
          game.productSummary.domain = game.productSummary.productName
            .split('-')
            .slice(0, -1)
            .join('-')
        }
      }

      if (game.productSummary.productName && game.productSummary.lotteryID === 5) {
        game.productSummary.domain = game.productSummary.productName;
        game.productSummary.serie = '001';
      }
    }

    if (game.draw) {
      game.draw = new DrawModel(game.draw)
    }

    return {
      lottery: lottery,
      game: game || null
    }
  } catch (err) {
    console.error(err)
    return new Error(err);
  }
}
